import RequestMaster from '../RequestMaster'

export default class RequestIncidenciaFichaje extends RequestMaster {

    constructor() {
        super()
        this.URL_BASE = this.URL_BASE + '/empleado/fichaje/incidencia'
    }
}
